<!-- EditorComponent.vue -->
<template>
    <div style="border: 1px solid #ccc;">
        <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
        <Editor style="height: 500px; overflow-y: hidden;" v-model="localContent" :defaultConfig="localEditorConfig" :mode="mode"
            @onCreated="onCreated" />
    </div>
</template>
  
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
    components: { Editor, Toolbar },
    props: {
        value: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'default'
        },
        toolbarConfig: {
            type: Object,
            default: () => ({})
        },
        editorConfig: {
            type: Object,
            default: () => (
                {}
            )
        }
    },
    data() {
        return {
            editor: null,
            localEditorConfig:{
            placeholder: '请输入内容...',
            MENU_CONF: {
                uploadImage: {
                    server: this.$imgUrl,
                    fieldName: "file",
                    headers: {
                        Authorization: "Bearer " + sessionStorage.getItem("token")
                    },
                    onSuccess(file, res) {
                    },
                    customInsert: (res, insertFn) => {                  // JS 语法
                        // 从 res 中找到 url alt href ，然后插入图片
                        console.log('res---', res)
                        insertFn(this.imgserver + res.result)
                    },
                }
            },
        },
            localContent: this.value 
        }
    },
    mounted() {
    },
    watch: {
        value(newContent) {
        if (this.localContent !== newContent) {
            this.localContent = newContent;  // 当 value 改变时，更新 localContent
        }
    },
    localContent(newContent) {
        // 如果有图片，需要加一个style 样式，控制图片大小
        // let img = newContent.match(/<img.*?(?:>|\/>)/gi);
        // if (img) {
        //     for (let i = 0; i < img.length; i++) {
        //         let t = img[i].replace(/style=\"/gi, "style=\"max-width:100%;height:auto;");
        //         newContent = newContent.replace(img[i], t);
        //     }
        // }
      this.$emit('input', newContent);  // 当 localContent 改变时，触发 input 事件来更新 value
    },
    editorConfig(newConfig) {
      this.localEditorConfig = newConfig;  // 当 editorConfig 改变时，更新 localEditorConfig
    },
    toolbarConfig(newConfig) {
      this.localToolbarConfig = newConfig;  // 当 toolbarConfig 改变时，更新 localToolbarConfig
    }
    },

    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        }
    }
}
</script>